<div class="host __dashboard">
  <input type="text" (change)="onChanges()" #tagify>
</div>